export interface Appearance {
	colorMode: "dark" | "light";
	liquidGlass: boolean;
}

export function readAppearance(value: unknown): Appearance {
	const saved = value && typeof value === "object" ? value as Partial<Appearance> : {};
	return {
		colorMode: saved.colorMode === "light" ? "light" : "dark",
		liquidGlass: saved.liquidGlass !== false,
	};
}

export function applyAppearance(appearance: Appearance): void {
	document.documentElement.dataset.colorMode = appearance.colorMode;
	document.documentElement.dataset.liquidGlass = String(appearance.liquidGlass);
	document.querySelector('meta[name="theme-color"]')?.setAttribute("content", appearance.colorMode === "light" ? "#f3f5f7" : "#0a0c0f");
}